import React from "react";
import { useNavigate } from "react-router-dom";
import ACard from "../../Materials/ACard";
import classes from "../../../styles/CreateBlog.module.css";

const CreateBlog = () => {
  const titleRef = React.useRef("");
  const paraRef = React.useRef("");
  const [isLoading, setIsLoading] = React.useState(false);
  const navigation = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    const enteredTitle = titleRef.current.value;
    const enteredPara = paraRef.current.value;
    titleRef.current.value = "";
    paraRef.current.value = "";

    if (enteredTitle.trim().length === 0 || enteredPara.trim().length === 0) {
      alert("Please enter title and para");
      return;
    }
    const datafetched = {
      title: enteredTitle,
      para: enteredPara,
      id: Math.random(),
    };
    setIsLoading(true);
    try {
      const res = await fetch(
        "https://overvalue-8fc05-default-rtdb.firebaseio.com/nexula.json",
        {
          method: "POST",
          body: JSON.stringify(datafetched),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!res.ok) {
        setIsLoading(false);
        return res.json().then((data) => {
          if (data || data.error || data.error.message) {
            alert(data.error.message + " " + data.error.code);
            throw new Error(data.error.message);
          }
        });
      } else {
        navigation("/blog", { replace: true });
        alert("Blog Created");
      }
    } catch (err) {
      console.log(err);
      alert("Error: " + err.message);
    }
  };
  return (
    <section className={classes.section}>
      <h1>Create Blog</h1>
      <form onSubmit={submitHandler}>
        <div className={classes.control}>
          <label htmlFor="title">Title</label>
          <input type="text" id="title" placeholder="Title" ref={titleRef} />
        </div>
        <div className={classes.control}>
          <label htmlFor="para">Para</label>
          <textarea
            type="para"
            id="para"
            row="5"
            column="10"
            placeholder="Para"
            ref={paraRef}
          />
        </div>
        <div className={classes.actions}>
          <button type="submit">{isLoading ? "Sending to database..." : "Create"}</button>
        </div>
      </form>
    </section>
  );
};

export default CreateBlog;
